module.exports = __webpack_public_path__ + "media/images/front/about/thumbnail8-9e8f8088a3043cc08bf8cb46ffa47bb2.jpg";